import t from "@/lang/lang";
import {
  BaseDataPage,
  BaseDataPageContent,
  BaseDataPageHeader,
  BaseDataPageTitle,
} from "@/routes/base-data/_components/layout/base-data-page";
import {
  PestGroupsTable,
  PestsTable,
} from "@/services/backend/pestcontrol/components/pests-table";
import { useFeatureAuth } from "@/services/backend/auth/hooks/use-feature-auth";
import { useActiveCompany } from "@/shared/lib/active-company/active-company-provider";
import { Card, CardContent } from "@/shared/components/ui/card";
import { Alert403 } from "@/shared/components/alerts/alert-403";
import { Outlet } from "react-router";

export function PestcontrolBaseDataRoute() {
  const canAccess = useFeatureAuth("gsm.pestcontrol");

  if (!canAccess) {
    return (
      <BaseDataPage>
        <Alert403 />
      </BaseDataPage>
    );
  }

  return <Outlet />;
}

export function PestcontrolRoute() {
  const { companyId } = useActiveCompany();

  return (
    <BaseDataPage>
      <BaseDataPageHeader>
        <BaseDataPageTitle>{t("Schädlingsbekämpfung")}</BaseDataPageTitle>
      </BaseDataPageHeader>
      <BaseDataPageContent>
        <Card>
          <CardContent className="space-y-4">
            <PestGroupsTable companyId={companyId} />
            <PestsTable companyId={companyId} />
          </CardContent>
        </Card>
      </BaseDataPageContent>
    </BaseDataPage>
  );
}
